import { render, staticRenderFns } from "./search.vue?vue&type=template&id=7f865ff4&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=7f865ff4&prod&lang=scss"
import style1 from "./search.vue?vue&type=style&index=1&id=7f865ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f865ff4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default})
